export default {"src":"/_next/static/media/MULN.c0825a7a.svg","height":18,"width":18};